'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export const PageviewAnalytics = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (pathname) {
      // https://developers.google.com/tag-platform/gtagjs/reference/events#page_view
      window.gtag('event', 'page_view', {
        page_location: window.location.href,
      });
    }
  }, [pathname, searchParams]);

  return null;
};
